import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Article } from '../../models/Article';
import { ArticlesService } from '../../services/articles.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css']
})
export class ArticleComponent implements OnInit {

  slug: String;
  isLoading = true;
  responseArticlesData: Article;

  constructor(private route: ActivatedRoute, private articlesService: ArticlesService, private title: Title, private meta: Meta) {

  }
  ngOnInit() {

    this.isLoading = true;

    this.route.paramMap.subscribe(params => {

      this.slug = params.get('slug');

      this.articlesService.getArticle(this.slug).subscribe(data => {
        this.isLoading = false;
        this.responseArticlesData = data;

        this.title.setTitle(this.responseArticlesData.metaTitle);
        this.meta.addTag({ name: 'description', content: this.responseArticlesData.metaDescription });
        this.meta.addTag({ name: 'author', content: 'Polish Travel Quo Vadis - Dział bilety lotnicze' });
        this.meta.addTag({ name: 'keywords', content: this.responseArticlesData.metaKeywords });
      });
    });
  }
}
